var _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSotDots(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 100,
    viewBox: "0 0 95 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.5001,
    cy: 6.75676,
    rx: 6.78571,
    ry: 6.75676,
    fill: "#1BACE4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.0001,
    cy: 29.7297,
    rx: 5.42857,
    ry: 5.40541,
    fill: "#EC1C24"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.8571,
    cy: 17.5676,
    rx: 4.07143,
    ry: 4.05405,
    fill: "#1BACE4"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.8571,
    cy: 82.4324,
    rx: 4.07143,
    ry: 4.05405,
    fill: "#1BACE4"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.07143,
    cy: 50,
    rx: 4.07143,
    ry: 4.05405,
    fill: "#1BACE4"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.9286,
    cy: 50,
    rx: 4.07143,
    ry: 4.05405,
    fill: "#1BACE4"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.8571,
    cy: 17.5676,
    rx: 4.07143,
    ry: 4.05405,
    fill: "#1BACE4"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.8571,
    cy: 82.4324,
    rx: 4.07143,
    ry: 4.05405,
    fill: "#1BACE4"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.7142,
    cy: 29.7297,
    rx: 5.42857,
    ry: 5.40541,
    fill: "#EC1C24"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.0001,
    cy: 70.2703,
    rx: 5.42857,
    ry: 5.4054,
    fill: "#EC1C24"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.7142,
    cy: 70.2703,
    rx: 5.42857,
    ry: 5.4054,
    fill: "#EC1C24"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.5,
    cy: 50,
    rx: 9.5,
    ry: 9.45946,
    fill: "#141414"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.5714,
    cy: 50,
    rx: 5.42857,
    ry: 5.40541,
    fill: "#EC1C24"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.7857,
    cy: 50,
    rx: 5.42857,
    ry: 5.40541,
    fill: "#EC1C24"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.5001,
    cy: 93.2432,
    rx: 6.78571,
    ry: 6.75676,
    fill: "#1BACE4"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.50007,
    cy: 71.6216,
    rx: 6.78571,
    ry: 6.75676,
    fill: "#1BACE4"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.5001,
    cy: 71.6216,
    rx: 6.78571,
    ry: 6.75676,
    fill: "#1BACE4"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.50007,
    cy: 28.3784,
    rx: 6.78571,
    ry: 6.75676,
    fill: "#1BACE4"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.5001,
    cy: 28.3784,
    rx: 6.78571,
    ry: 6.75676,
    fill: "#1BACE4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSotDots);
export default __webpack_public_path__ + "static/media/sotDots.6349868a9048d95ed40b5b80b37c1b2e.svg";
export { ForwardRef as ReactComponent };